import { useMemo } from 'react';
import { theme } from '../theme';
import { useBudget } from '../store/BudgetContext';
import { useOnboardingClaims } from '../hooks/useOnboardingClaims';
import { detectSteps, showOnboarding, OnboardingStep } from '../utils/onboarding';

/**
 * Карточка «Первая неделя» — онбординг-прогресс для новых household.
 * Рендерится только если showOnboarding true.
 * Клеймит монеты за каждый выполненный шаг через useOnboardingClaims.
 */
export function OnboardingCard() {
  const { viewData } = useBudget();

  const steps: OnboardingStep[] | null = useMemo(() => {
    if (!viewData) return null;
    if (!showOnboarding(viewData)) return null;
    return detectSteps(viewData);
  }, [viewData]);

  // Хук вызывается безусловно (правила хуков). При steps=null эффект — ноль.
  useOnboardingClaims(steps);

  if (!steps) return null;

  const doneCount = steps.filter((s) => s.done).length;

  return (
    <div
      style={{
        background: theme.colors.card,
        borderRadius: theme.radius.md,
        border: `1px solid ${theme.colors.line}`,
        padding: '14px 16px',
        marginTop: 8,
      }}
    >
      {/* Заголовок */}
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          marginBottom: 10,
        }}
      >
        <span
          style={{
            fontFamily: theme.fontDisplay,
            fontSize: 15,
            fontWeight: 600,
            color: theme.colors.ink,
            letterSpacing: '-0.01em',
          }}
        >
          Первая неделя
        </span>
        <span
          style={{
            fontFamily: theme.font,
            fontSize: 12,
            color: theme.colors.sub,
          }}
        >
          {doneCount} из 5
        </span>
      </div>

      {/* Hairline */}
      <div
        style={{
          height: 1,
          background: theme.colors.line,
          marginBottom: 10,
        }}
      />

      {/* Шаги */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        {steps.map((step) => (
          <div
            key={step.key}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span
              style={{
                width: 16,
                height: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                fontSize: 13,
                color: step.done ? theme.colors.green : theme.colors.sub,
                fontFamily: theme.font,
              }}
            >
              {step.done ? '✓' : '·'}
            </span>
            <span
              style={{
                fontFamily: theme.font,
                fontSize: 13,
                color: step.done ? theme.colors.ink : theme.colors.sub,
              }}
            >
              {step.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
